import type { CSSProperties } from 'react';

/** Internal SVG icon set (stroke icons, 24×24). */
const P: Record<string, string> = {
  today: 'M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M5.6 18.4 7 17M17 7l1.4-1.4M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z',
  learn: 'M3 7l9-4 9 4-9 4-9-4ZM7 9v5c0 1.7 2.2 3 5 3s5-1.3 5-3V9M21 7v6',
  courses: 'M4 5h7a3 3 0 0 1 3 3v12a2 2 0 0 0-2-2H4V5ZM20 5h-3a3 3 0 0 0-3 3v12a2 2 0 0 1 2-2h4V5Z',
  subjects: 'M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 17h6M17 14v6',
  map: 'M12 12m-2 0a2 2 0 1 0 4 0 2 2 0 1 0-4 0M5 6m-1.5 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0M19 6m-1.5 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0M6 19m-1.5 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0M18 18m-1.5 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0M6.3 7l4.2 3.7M17.6 7l-4.2 3.7M7.2 17.8l3.3-4.3M16.7 16.8l-3.3-3.4',
  planner: 'M4 6h16v14H4zM4 10h16M9 3v4M15 3v4M8 14h3M13 14h3M8 17h3',
  exams: 'M9 4h6l1 2h3v15H5V6h3l1-2ZM9 11l2 2 4-4M9 17h6',
  goals: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10ZM12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
  mastery: 'M12 3l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.4 6.8 19.1l1-5.8L3.5 9.2l5.9-.9L12 3Z',
  analytics: 'M4 20V10M10 20V4M16 20v-7M22 20H2',
  mistakes: 'M12 9v4M12 17h.01M10.3 3.9 2.4 18a2 2 0 0 0 1.7 3h15.8a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z',
  reviews: 'M3 12a9 9 0 1 0 3-6.7L3 8M3 3v5h5M12 7v5l3 2',
  profile: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM4 21c1-4 4.5-6 8-6s7 2 8 6',
  quests: 'M5 21V4M5 4h11l-2 4 2 4H5',
  achievements: 'M8 4h8v5a4 4 0 0 1-8 0V4ZM8 6H4a3 3 0 0 0 4 4M16 6h4a3 3 0 0 1-4 4M12 13v4M8 21h8M10 17h4',
  notes: 'M6 3h9l4 4v14H6V3ZM15 3v4h4M9 12h7M9 16h5',
  palace: 'M3 21h18M5 21V10M19 21V10M9 21v-6h6v6M3 10l9-7 9 7',
  settings: 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-2.9 1.2V21a2 2 0 0 1-4 0v-.1a1.7 1.7 0 0 0-2.9-1.2l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0-1.2-2.9H3a2 2 0 0 1 0-4h.1a1.7 1.7 0 0 0 1.2-2.9l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 2.9-1.2V3a2 2 0 0 1 4 0v.1a1.7 1.7 0 0 0 2.9 1.2l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0 1.2 2.9H21a2 2 0 0 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1Z',
  search: 'M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14ZM21 21l-4.3-4.3',
  bell: 'M6 8a6 6 0 1 1 12 0c0 7 3 9 3 9H3s3-2 3-9M10.3 21a1.9 1.9 0 0 0 3.4 0',
  flame: 'M12 2c1 4-3 5-3 9a3 3 0 0 0 6 0c0-1.6-1-2.6-1-4 2 1 4 3.5 4 7a6 6 0 0 1-12 0c0-5 6-7 6-12Z',
  sigma: 'M18 5H6l6 7-6 7h12',
  quill: 'M20 4C11 4 6 10 5 20M14 9 9 14M5 20l3-1',
  globe: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM3 12h18M12 3c2.5 2.7 3.8 5.7 3.8 9s-1.3 6.3-3.8 9c-2.5-2.7-3.8-5.7-3.8-9S9.5 5.7 12 3Z',
  atom: 'M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM12 21c2 0 3.5-4 3.5-9S14 3 12 3 8.5 7 8.5 12s1.5 9 3.5 9ZM4.2 16.5c1 1.7 5.3 1.1 9.6-1.4s7-5.9 6-7.6-5.3-1.1-9.6 1.4-7 5.9-6 7.6ZM4.2 7.5c-1 1.7 1.7 5.1 6 7.6s8.6 3.1 9.6 1.4-1.7-5.1-6-7.6-8.6-3.1-9.6-1.4Z',
  pillar: 'M3 21h18M4 9h16M12 3l9 6H3l9-6ZM6 9v10M10 9v10M14 9v10M18 9v10',
  lotus: 'M12 20c-4 0-8-2-9-6 3 0 6 1 9 4 3-3 6-4 9-4-1 4-5 6-9 6ZM12 18c-2-2-3-5-3-8 0-2 1-4 3-6 2 2 3 4 3 6 0 3-1 6-3 8Z',
  speech: 'M4 5h16v11H9l-5 4V5ZM8 9h8M8 12h5',
  play: 'M7 4v16l13-8L7 4Z',
  check: 'M4 12l5 5L20 6',
  x: 'M6 6l12 12M18 6 6 18',
  'arrow-right': 'M5 12h14M13 6l6 6-6 6',
  'arrow-left': 'M19 12H5M11 6l-6 6 6 6',
  plus: 'M12 5v14M5 12h14',
  trash: 'M4 7h16M10 11v6M14 11v6M5 7l1 13h12l1-13M9 7V4h6v3',
  edit: 'M4 20h4L19 9l-4-4L4 16v4ZM14 6l4 4',
  spark: 'M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5 18 18M6 18l2.5-2.5M15.5 8.5 18 6',
  target: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM12 3v3M12 18v3M3 12h3M18 12h3',
  clock: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM12 7v5l3 2',
  crown: 'M3 8l4 4 5-7 5 7 4-4-2 11H5L3 8Z',
  sword: 'M14.5 3H21v6.5L10 20.5 3.5 14 14.5 3ZM6 15l3 3M3 21l3-3',
  shield: 'M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6l8-3Z',
  brain: 'M9 4a3 3 0 0 0-3 3 3 3 0 0 0-2 5 3 3 0 0 0 2 5 3 3 0 0 0 6 1V5a3 3 0 0 0-3-1ZM15 4a3 3 0 0 1 3 3 3 3 0 0 1 2 5 3 3 0 0 1-2 5 3 3 0 0 1-6 1',
  bolt: 'M13 2 4 14h7l-1 8 9-12h-7l1-8Z',
  lock: 'M6 11h12v10H6zM8 11V8a4 4 0 0 1 8 0v3',
  unlock: 'M6 11h12v10H6zM8 11V8a4 4 0 0 1 7.5-2',
  volume: 'M4 9h4l5-4v14l-5-4H4V9ZM16 9a4 4 0 0 1 0 6M18.5 6.5a8 8 0 0 1 0 11',
  menu: 'M4 7h16M4 12h16M4 17h16',
  filter: 'M4 5h16l-6 8v6l-4-2v-4L4 5Z',
  'zoom-in': 'M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14ZM21 21l-4.3-4.3M11 8v6M8 11h6',
  'zoom-out': 'M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14ZM21 21l-4.3-4.3M8 11h6',
  focus: 'M4 8V4h4M16 4h4v4M20 16v4h-4M8 20H4v-4M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
  link: 'M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1',
  'chevron-down': 'M6 9l6 6 6-6',
  'chevron-right': 'M9 6l6 6-6 6',
  info: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM12 11v5M12 8h.01',
  hex: 'M12 2l8.7 5v10L12 22l-8.7-5V7L12 2Z',
  layers: 'M12 3 2 8l10 5 10-5-10-5ZM2 13l10 5 10-5M2 17l10 5 10-5',
  book: 'M5 4h12a2 2 0 0 1 2 2v14H7a2 2 0 0 1-2-2V4ZM5 18a2 2 0 0 1 2-2h12',
  pen: 'M12 20h9M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5Z',
  dive: 'M12 3v14M6 11l6 6 6-6M4 21h16',
  edge: 'M3 20 12 4l9 16M8 14h8',
  repeat: 'M17 2l4 4-4 4M3 11V9a3 3 0 0 1 3-3h15M7 22l-4-4 4-4M21 13v2a3 3 0 0 1-3 3H3',
  stars: 'M12 3l1.5 3 3.5.5-2.5 2.5.5 3.5L12 11l-3 1.5.5-3.5L7 6.5l3.5-.5L12 3ZM5 15l1 2 2 .3-1.5 1.4.4 2.1L5 19.8l-1.9 1 .4-2.1L2 17.3 4 17l1-2ZM19 15l1 2 2 .3-1.5 1.4.4 2.1-1.9-1-1.9 1 .4-2.1-1.5-1.4L18 17l1-2Z',
  hundred: 'M4 8l2-1v10M10 8a2 2 0 0 1 4 0v8a2 2 0 0 1-4 0V8ZM16 8a2 2 0 0 1 4 0v8a2 2 0 0 1-4 0V8Z',
  note: 'M6 3h9l4 4v14H6V3ZM9 12h7M9 16h5',
  balance: 'M12 3v18M5 21h14M6 7h12M6 7l-3 7a3 3 0 0 0 6 0L6 7ZM18 7l-3 7a3 3 0 0 0 6 0l-3-7Z',
  cap: 'M2 9l10-5 10 5-10 5L2 9ZM6 11v5c0 1.5 2.7 3 6 3s6-1.5 6-3v-5',
  calendar: 'M4 6h16v14H4zM4 10h16M9 3v4M15 3v4',
  flag: 'M5 21V4M5 4h11l-2 4 2 4H5',
  refresh: 'M20 11a8 8 0 0 0-14.9-3M4 4v4h4M4 13a8 8 0 0 0 14.9 3M20 20v-4h-4',
  eye: 'M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12ZM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
  hint: 'M9 18h6M10 21h4M12 3a6 6 0 0 0-3.5 10.9c.6.4 1 1.2 1 2.1h5c0-.9.4-1.7 1-2.1A6 6 0 0 0 12 3Z',
  swords: 'M14.5 17.5 3 6V3h3l11.5 11.5M13 19l6-6M16 16l4 4M19 21l2-2M9.5 6.5 21 18v3h-3L6.5 9.5M11 5 5 11M8 8 4 4M5 3 3 5',
  map2: 'M9 4 3 6v14l6-2 6 2 6-2V4l-6 2-6-2ZM9 4v14M15 6v14',
  sparkle: 'M12 2l1.8 6.2L20 10l-6.2 1.8L12 18l-1.8-6.2L4 10l6.2-1.8L12 2Z',
  assess: 'M9 3h6v3H9zM7 4.5H5V21h14V4.5h-2M8.5 13l2.5 2.5 4.5-5M8.5 18h7',
  mute: 'M4 9h4l5-4v14l-5-4H4V9ZM17 9l5 6M22 9l-5 6',
  sun: 'M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4',
  moon: 'M20 14.5A8.5 8.5 0 1 1 9.5 4a7 7 0 0 0 10.5 10.5Z',
  language: 'M4 5h9M8.5 3v2M6 5c.5 3 2.5 5.5 5.5 7M11 5c-.5 3.5-3 6.5-7 8M13 21l4-10 4 10M14.3 18h5.4',
  flask: 'M9 3h6M10 3v6L4.5 18.5A1.7 1.7 0 0 0 6 21h12a1.7 1.7 0 0 0 1.5-2.5L14 9V3M7 15h10',
  sticker: 'M4 4h11l5 5v11H4V4ZM15 4v5h5M9 13.5a1.5 1.5 0 1 0 0-3M15 11.5c0 2-1.5 3.5-3.5 3.5S8 14 8 12',
  house: 'M3 11l9-7 9 7M5 9.5V21h14V9.5M10 21v-6h4v6',
  sofa: 'M4 11V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3M2 13a2 2 0 0 1 4 0v2h12v-2a2 2 0 0 1 4 0v5H2v-5ZM5 18v2M19 18v2',
  coffee: 'M10 3v2M14 3v2',
};

export type IconName = keyof typeof P | string;

export function Icon({ name, size, style, className }: { name: IconName; size?: number; style?: CSSProperties; className?: string }) {
  const d = P[name] ?? P.hex;
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round" style={style} className={className} aria-hidden="true">
      <path d={d} />
    </svg>
  );
}

export const SUBJECT_GLYPH: Record<string, string> = {
  math: 'sigma', norwegian: 'quill', english: 'globe', science: 'atom', social: 'pillar', krle: 'lotus',
  french: 'speech', german: 'speech', polish: 'speech', tagalog: 'speech',
};
